import axios from 'axios';
import { req } from './axiosFun';

/**
 * 订单管理-交易订单
 **/
// 交易订单-获取交易订单列表
export const OrderList = (params) => { return req("post", "/orderList/"+params.pageIndex+'/'+params.pageSize) };
// 交易订单-删除交易订单
export const OrderDelete = (params) => { return axios.delete("/api/Order/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 交易订单-交易订单退款
export const OrderRefund = (params) => { return req("post", "/api/Order/refund", params) };



// WEBPACK FOOTER //
// ./src/api/payMG.js